import _ from 'lodash';
import store from '../store';
import { formatDate } from '../utils/dateUtil.js'

const TAG = '工具';

export function filterEmptyFields(obj) {
    // 输入参数校验
    if (typeof obj !== 'object' || obj === null) {
        console.warn('filterEmptyFields: 参数必须是对象类型');
        return {};
    }

    // 创建一个新对象
    const result = {};

    // 遍历原始对象的所有属性
    for (const key in obj) {
        // 使用Object.prototype.hasOwnProperty.call替代obj.hasOwnProperty
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const value = obj[key];

            // 检查值是否不为null、不为空字符串、不为undefined
            if (value !== null && value !== '' && value !== undefined) {
                result[key] = value;
            }
        }
    }

    return result;
}

/**
 * 将对象值映射到数组的value中
 * @param {Array} dataArray - 数组格式：[{label, value, key}, ...]
 * @param {Object} sourceObj - 数据源对象格式：{key1: value1, key2: value2, ...}
 * @returns {Array} 处理后的数组
 */
export function mapValuesToArray(dataArray, sourceObj) {
    return dataArray.map(item => {
        // 复制原对象
        const newItem = { ...item };
        // 如果sourceObj中有对应的key，则用其值替换value
        if (item.key && sourceObj[item.key] !== undefined) {
            newItem.value = sourceObj[item.key];
        }
        return newItem;
    });
}

export function getNameByValue(list, value) {
    const item = list.find(item => item.value === value);
    return item ? item.name : '';
}

export function commonFormatterValue(value, key) {
    console.log(TAG, 'commonFormatterValue value&key', value, key)

    switch (key) {
        case 'resourceType':  // 资源类型
            {
                const list = store.state.asset.resourceTypeList;
                const result = getNameByValue(list, value);
                console.log(TAG, 'commonFormatterValue resourceType result=', result)
                return result;
            }
        case 'paymentStatus': // 缴费状态
            {
                const list = store.state.asset.paymentStatusList;
                const result = getNameByValue(list, value);
                console.log(TAG, 'commonFormatterValue paymentStatus result=', result)
                return result;
            }
        case 'currentStatus': // 租控状态
            {
                const list = store.state.asset.currentStatusList;
                const result = getNameByValue(list, value);
                console.log(TAG, 'commonFormatterValue currentStatus result=', result)
                return result;
            }
        case 'contractType': // 合同类型
            {
                return value;
            }

        default:
            break;
    }
}


export function commonFormatter(row, field) {
    // console.log(TAG, 'commonFormatter row&field', row, field)
    switch (field) {
        case 'resourceType': // 资源类型
            {
                const value = _.get(row, field);
                const list = store.state.asset.resourceTypeList;
                const result = getNameByValue(list, value);
                // console.log(TAG, 'commonFormatter resourceType result=', result)
                return result;
            }

        case 'rentStatus': // 租控状态，不用break
        case 'currentStatus':// 租控状态
            {
                const value = _.get(row, field);
                const list = store.state.asset.currentStatusList;
                const result = getNameByValue(list, value);
                // console.log(TAG, 'commonFormatter currentStatus result=', result)
                return result;
            }
        case 'paymentStatus': // 缴费状态
            {
                const value = _.get(row, field);
                const list = store.state.asset.paymentStatusList;
                const result = getNameByValue(list, value);
                // console.log(TAG, 'commonFormatter currentStatus result=', result)
                return result;
            }
        case 'value.currentStatus': // 缴费状态
            {
                const value = _.get(row, 'value');
                const list = store.state.asset.currentStatusList;
                const result = getNameByValue(list, value);
                // console.log(TAG, 'commonFormatter value.currentStatus result=', result)
                return result;
            }
        case 'value.resourceType': // 资源类型
            {
                const value = _.get(row, 'value');
                const list = store.state.asset.resourceTypeList;
                const result = getNameByValue(list, value);
                // console.log(TAG, 'commonFormatter value.resourceType result=', result)
                return result;
            }
        case 'value.rentCycle': // 支付方式
            {
                const value = _.get(row, 'value');
                const list = store.state.asset.rentCycleList;
                const result = getNameByValue(list, value);
                // console.log(TAG, 'commonFormatter value.rentCycle result=', result)
                return result;
            }
        case 'reconciliationTime': // 平账时间
            {
                const value = _.get(row, field);
                const result = formatDate(value);
                // console.log(TAG, 'commonFormatter reconciliationTime result=', result)
                return result;
            }
        case 'expiryDate': // 到期日期 和签约日期一样，不用break
        case 'signDate': // 签约日期
            {
                const value = _.get(row, field);
                const result = formatDate(value);
                // console.log(TAG, 'commonFormatter signDate result=', result)
                return result;
            }
        case 'contract.endTime': // 签约日期
            {
                const value = _.get(row, field) || '';
                const result = formatDate(value, 'yyyy-MM-dd');
                // console.log(TAG, 'commonFormatter contract.endTime result=', result)
                return result;
            }
        case 'contract.partyB': // 租客
            {
                const value = _.get(row, field) || '';
                // console.log(TAG, 'commonFormatter contract.endTime result=', value)
                return value;
            }
        case 'state': // 状态
            {
                console.log(TAG, 'commonFormatter row&field', row, field)
                const expring = _.get(row, 'contract.expiring');
                if (expring) {
                    return '即将到期'
                } else {
                    const value = _.get(row, field) || '';
                    const list = store.state.asset.stateList;
                    const result = getNameByValue(list, value);
                    console.log(TAG, 'commonFormatter state result=', result)
                    return result;
                }

            }
        case 'contractStatus': // 合同状态
            {
                // EXECUTING,EXPIRED,PENDING,TERMINATED,UNDEFINED
                const value = _.get(row, field) || '';
                return value;

            }
        case 'contractType': // 	合同类型
            {
                // 可用值: CONTRACT, INTENTION, UNDEFINED
                const value = _.get(row, field) || '';
                return value;
            }
        default:
            {
                return _.get(row, field)
            }

    }
}

/**
 * 安全的除法运算函数
 * @param {number} dividend 被除数
 * @param {number} divisor 除数
 * @param {number|string} defaultValue 除数为0或无效时的默认值，默认为0
 * @returns {number} 除法结果或默认值
 */
export function safeDivide(dividend, divisor, defaultValue = 0) {
    // 1. 参数验证 - 确保是有效数字
    const isNumber = (value) => typeof value === 'number' && !isNaN(value);

    // 2. 被除数无效时返回默认值
    if (!isNumber(dividend)) {
        console.warn(`被除数 ${dividend} 不是有效数字，返回默认值 ${defaultValue}`);
        return defaultValue;
    }

    // 3. 除数无效时返回默认值
    if (!isNumber(divisor)) {
        console.warn(`除数 ${divisor} 不是有效数字，返回默认值 ${defaultValue}`);
        return defaultValue;
    }

    // 4. 除数接近0时的处理
    const MIN_ABS_DIVISOR = 1e-10; // 定义一个极小的阈值

    if (Math.abs(divisor) < MIN_ABS_DIVISOR) {
        console.warn(`除数 ${divisor} 接近0，返回默认值 ${defaultValue}`);
        return defaultValue;
    }

    // 5. 执行除法并处理可能的精度问题
    const result = dividend / divisor;

    // 6. 检查结果是否有效
    if (!isNumber(result)) {
        console.warn(`除法结果无效，返回默认值 ${defaultValue}`);
        return defaultValue;
    }

    return result;
}

export function isEmptyValue(value) {
    // 判断是否为 undefined
    if (value === undefined) return true;

    // 判断是否为 null
    if (value === null) return true;

    // 判断是否为 "" 空字符串
    if (typeof value === 'string' && value.trim() === "") return true;

    // 判断是否为空数组 []
    if (Array.isArray(value) && value.length === 0) return true;

    // 判断是否为空对象 {}
    if (typeof value === 'object' && value !== null) {
        // 检查对象自身可枚举属性的数量
        return Object.keys(value).length === 0;
    }

    return false;
}
